import React, { useRef, useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const LineChartDuo = ({ data, firstKey, secondKey }) => {
  const containerRef = useRef(null);
  const [fontSize, setFontSize] = useState(11);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        // Adjust font size based on width, clamp between 9 and 14
        const newFontSize = Math.max(9, Math.min(14, Math.round(width / 60)));
        setFontSize(newFontSize);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [chartHeight, setChartHeight] = useState(500);
  const [chartMargins, setChartMargins] = useState({ top: 25, bottom: 25, left: 60, right: 20 });
  const [labelAngle, setLabelAngle] = useState(-35);

  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        
        if (width < 600) {
          setChartHeight(450);
          setChartMargins({ top: 20, bottom: 80, left: 10, right: 10 });
          setLabelAngle(-90);
        } else if (width < 900) {
          setChartHeight(500);
          setChartMargins({ top: 25, bottom: 60, left: 90, right: 20 });
          setLabelAngle(-35);
        } else {
          setChartHeight(550);
          setChartMargins({ top: 25, bottom: 50, left: 100, right: 20 });
          setLabelAngle(-35);
        }
      }
    };
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <div ref={containerRef} style={{ width: '100%', height: chartHeight, position: "relative", marginTop: 30, minHeight: 350 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={chartMargins}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            interval={0}
            angle={labelAngle}
            textAnchor="end"
            dy={5}
            dx={labelAngle === -90 ? 0 : -5}
            height={80}
            tick={{ fontSize }}
          />
          <YAxis />
          <Tooltip />
          <Legend align="left" verticalAlign="top" wrapperStyle={{ paddingBottom: 10 }} />
          <Line
            type="monotone"
            dataKey={firstKey}
            stroke="#8884d8"
            strokeWidth={4} // Make blue line bold
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            dataKey={secondKey}
            stroke="#82ca9d"
            strokeWidth={4} // Make green line bold
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default LineChartDuo;